import { api } from "./axiosInstance";

export type RepTop30Item = {
  id: string;
  name: string;
  image_url?: string;
  relationship_level?: number | null;
  roles_ids?: string[];
  markets_ids?: string[];
  locations_ids?: string[];
  reps_ids?: string[];
  account_representative?: string;
};

export type RepTop30Response = {
  data: RepTop30Item[];
};

export const apiGetRepTop30 = async (repId: string): Promise<RepTop30Response> => {
  const response = await api.get("/api/page/profile/top30", {
    params: { repId },
  });
  return response.data;
};
